import React, { useEffect, useState, useCallback } from "react";
import NominationService from "../Service/NominationService";
import { useFreezeNomination } from "../Context/FreezeNominationContext";
import MonthlyOfferingService from "../Service/MonthlyOfferingService";
import MasterCourseService from "../Service/MasterCourseService";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";

// function NominationFinalization_org() {
function NominationFinalization() {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [showCancelledModal, setShowCancelledModal] = useState(false); // New state for modal visibility
  const [showNoNominationsModal, setShowNoNominationsModal] = useState(false); // New state for modal visibility
  const [learningOfferings, setLearningOfferings] = useState([]);
  const [learningOfferingsWithNoNominations, setLearningOfferingsWithNoNominations] = useState([]);
  const [groupedCourses, setGroupedCourses] = useState([]);
  const [maxSMEsRequired, setMaxSMEsRequired] = useState(1);
  const [selectedNominations, setSelectedNominations] = useState([]); // New state for selected nominations
  const { isFrozen, toggleFreezeNomination } = useFreezeNomination(); // Get state and function from context
  const [sortCriteria, setSortCriteria] = useState([]); // Default sort by nominationTime

  const location = useLocation();
  const { user } = location.state || {}; // Extract user from location.state

  useEffect(() => {
    if (selectedMonth) {
      fetchLearningOfferingsByMonthAndTrack();
    }
  }, [selectedMonth]);

  const fetchLearningOfferingsByMonthAndTrack = useCallback(async () => {
    try {
      const response = await NominationService.getAllSMENominationsByMonthAndTrack(selectedMonth, user.track);
      if (response.length) {    
        setLearningOfferings(response);
        setShowTable(true);
      } else {
        setLearningOfferings([]);
        setShowTable(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setShowTable(false);
    }
  }, [selectedMonth, user.track]);

  // Group courses by componentCourseId, startDate, and endDate
  const groupCoursesByComponentId = (courses) => {
    const grouped = {};
    courses.forEach((course) => {
      const { componentCourseId, startDate, endDate } = course.monthlyOfferingBean;
      const key = `${componentCourseId}-${startDate}-${endDate}`;
      if (!grouped[key]) {
        grouped[key] = {
          ...course.monthlyOfferingBean, // Retain the course details
          nominatedUsers: [],
        };
      }

      // Push the user and userId into the nominatedUsers array
      grouped[key].nominatedUsers.push({
        name: course.userBean.name,
        userId: course.userBean.userId,
        confirmationStatus: course.confirmationStatus,
        totalTrainingDays: course.userBean.totalTrainingDays,
        nominationTime: course.nominationTime,
        smeId: course.smeId,
       });
      });

      return Object.values(grouped);
  };

    // Get the number of SMEs required for selected courses and calculate the status
    useEffect(() => {
      async function fetchSMEs() {
        const grouped = groupCoursesByComponentId(learningOfferings);
  
        const updated = await Promise.all(
          grouped.map(async (course) => {
            const numberOfSMEsRequired = await MasterCourseService.getNumberOfSmesByComponentCourseId(course.componentCourseId);
  
            const requiredSMEs = Number(numberOfSMEsRequired) || 1;
  
            // Get the session status from the backend
            const collectiveStatus = await MonthlyOfferingService.getSessionStatus(course.monthlyOfferingId);
  
            return {
              ...course,
              numberOfSMEsRequired: requiredSMEs,
              collectiveStatus,
            };
          })
        );
  
        setGroupedCourses(updated);
        setMaxSMEsRequired(Math.max(...updated.map((c) => c.numberOfSMEsRequired), 1));
      }

      if (learningOfferings.length) {
        fetchSMEs();
      }
    }, [learningOfferings, selectedNominations]);
     
  // Handle selection change for dropdown
  const handleSelectionChange = (monthlyOfferingId,smeIndex, userId) => {
    setSelectedNominations((prevNominations) => {
      // Check if the selection for the monthlyOfferingId already exists
      const existingNomination = prevNominations.find(
        (nomination) => nomination.monthlyOfferingId === monthlyOfferingId && nomination.smeIndex === smeIndex
      );

      if (existingNomination) {
        // If it exists, update the UserID
        return prevNominations.map((nomination) =>
          nomination.monthlyOfferingId === monthlyOfferingId && nomination.smeIndex === smeIndex
            ? { ...nomination, userId }
            : nomination
        );
      } else {
        return [...prevNominations, { monthlyOfferingId, smeIndex, smeId: `SME${smeIndex + 1}`, userId }];
      }
    });
  };

  const getCancelledOfferings = () => {
    return learningOfferings.filter((course) => course.confirmationStatus === "CANCELLED" || course.confirmationStatus === "OPTED_OUT");
  };

  // Handle Finalize Nomination button click
  const handleFinalizeNominations = async () => {
    try {
      const allSelections = [...selectedNominations];

      // get only the selection from allselections for which all required SME slots are filled
      const finalizedSelections = [];
      groupedCourses.forEach((course) => {
        const selectionsForCourse = allSelections.filter(
          (n) => n.monthlyOfferingId === course.monthlyOfferingId
        );
        const filledSlots = selectionsForCourse.filter(
          (n) => n.userId && n.userId !== ""
        ).length;
        if (filledSlots === course.numberOfSMEsRequired) {
          finalizedSelections.push(...selectionsForCourse);
        }
      });

      //finalize nominations and set session status to CONFIRMED where all SME s are present
      console.log("Finalized Selections to be sent:", finalizedSelections);
      const response = await NominationService.finalizeNomination(selectedMonth, finalizedSelections);
      alert(response);
      //get list of monthly offering ids from finalizedSelections
      //const monthlyOfferingIds = [...new Set(finalizedSelections.map(n => n.monthlyOfferingId))];

      // set sessionstatus by passing monthly offering ids
      // const response2 = await MonthlyOfferingService.setSessionStatus(monthlyOfferingIds, "CONFIRMED");
      //console.log("Set Session Status Response:", response2);

      await fetchLearningOfferingsByMonthAndTrack();
    } catch (error) {
        console.error("Error finalizing nomination:", error);
        setShowTable(false);
    }
  };

 // Handle handleOfferings With No Nominations button click
  const handleOfferingsWithNoNominations = async () => {
    try {
      const response = await MonthlyOfferingService.getAllUnnominatedCoursesWithinSelectedMonthAndTrack(selectedMonth, user.track);
      if (response.length !== 0) {
        setLearningOfferingsWithNoNominations(response);
        setShowNoNominationsModal(true);
      } else {
        setLearningOfferingsWithNoNominations([]);
        setShowNoNominationsModal(false);
      }
    } catch (error) {
      console.error("Error handling Offerings With No Nominations :", error);
      setShowTable(false);
    }
  };

  const downloadXLReport = async () => {
    console.log("User's track is " + user.track);
    const response = await NominationService.downloadFinalizedNominationsByTrack(selectedMonth, user.track);
  };

  return (
    <div className="overflow-x-auto p-3 bg-white rounded-lg shadow-md mt-4">
      <h2 className="text-2xl font-semibold mb-4" align="center">
        Nominations Finalization
      </h2>
        <div className="flex flex-col items-center mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="month">
            Select Month
          </label>
          <input
            id="month"
            type="month"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
             className="w-60 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
             required
          />
        </div>
        
      {showTable && groupedCourses.length > 0 && (
        <div className="mt-6 w-full overflow-x-auto">
          <div className="flex items-center space-x-6">
            {/* Freeze Nomination Toggle */}
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={isFrozen}
                onChange={toggleFreezeNomination}
                className="hidden"
              />
              <div
                className={`relative w-12 h-6 rounded-full ${isFrozen ? "bg-red-500" : "bg-green-500"
                  }`}
              >
                <div
                  className={`absolute top-0 left-0 w-6 h-6 bg-white rounded-full shadow-md transition-all duration-200 ${isFrozen ? "transform translate-x-6" : ""
                    }`}
                ></div>
              </div>
              <span className="ml-2 text-black">
                {isFrozen ? "Toggle to Unfreeze for Nominations" : "Toggle to Freeze Nominations"}
              </span>
            </label>

            {/* Dropdown with Label beside it */}
            <div className="flex items-center space-x-2">
              <label className="text-gray-700" htmlFor="sort">
                Select Sort Criteria for Nominated Users:
              </label>
              <select
                className="px-4 py-2 border rounded-md focus:outline-none"
                value={sortCriteria}
                onChange={(e) => setSortCriteria(e.target.value)}
              >
                <option value="" disabled>
                  -- Select --
                </option>
                <option value="nominationTime">Nomination Time</option>
                <option value="totalTrainingDays">Total Training Days</option>
              </select>
            </div>
          </div>


          <h3 className="text-xl font-semibold mb-4">Course Details</h3>
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr>
                <th className="px-1 py-1 border text-xs">Component Course Name</th>              
                <th className="px-1 py-1 border text-xs">Duration (Days)</th>
                <th className="px-1 py-1 border text-xs">Start Date</th>
                <th className="px-1 py-1 border text-xs">End Date</th>
                <th className="px-1 py-1 border text-xs">Comment</th>

                {[...Array(maxSMEsRequired)].map((_, idx) => (
                  <th key={idx} className="px-1 py-1 border text-xs">
                    SME {idx + 1}
                  </th>
                ))}
                <th className="px-1 py-1 border text-xs">Confirmation Status</th>
              </tr>
            </thead>
            <tbody>
            {groupedCourses.map((course) => (
                <tr key={course.componentCourseId} className="border-b">
                  <td className="px-1 py-1 border text-xs">{course.componentCourseName}</td>
                  <td className="px-1 py-1 border text-xs">{course.durationInDays}</td>
                  <td className="px-1 py-1 border text-xs">
                    {format(new Date(course.startDate), "dd-MMM-yyyy")}
                  </td>
                  <td className="px-1 py-1 border text-xs">
                    {format(new Date(course.endDate), "dd-MMM-yyyy")}
                  </td>
                  <td className="px-1 py-1 border text-xs">{course.comment}</td>

                  {/* SME dropdowns */}
                  {[...Array(maxSMEsRequired)].map((_, idx) => {
                    if (idx >= course.numberOfSMEsRequired) {
                      return <td key={idx} className="px-1 py-1 border text-xs"></td>;
                    }

                    const usersForSmeIndex = course.nominatedUsers.filter(
                      (u) =>
                        u.smeId === `SME${idx + 1}` &&
                        u.confirmationStatus !== "CANCELLED" &&
                        u.confirmationStatus !== "OPTED_OUT"
                    );

                    const confirmedUserForSmeIndex = (course.nominatedUsers ?? []).find(
                      (u) => u.smeId === `SME${idx + 1}` && u.confirmationStatus === "CONFIRMED"
                    );

                    const selectedValue =
                      selectedNominations.find(
                        (nomination) =>
                          nomination.monthlyOfferingId === course.monthlyOfferingId &&
                          nomination.smeIndex === idx
                      )?.userId ??
                      confirmedUserForSmeIndex?.userId ?? "";

                    return (
                      <td key={idx} className="px-1 py-1 border text-xs">
                        <select
                          className="w-full px-1 py-1 border rounded-md text-xs"
                          value={selectedValue}
                          onChange={(e) =>
                            handleSelectionChange(course.monthlyOfferingId, idx, e.target.value)
                          }
                        >
                          <option value="">--Select User--</option>
                          {
                            usersForSmeIndex.sort((a, b) => {
                            if (sortCriteria === "totalTrainingDays") {
                              return a.totalTrainingDays - b.totalTrainingDays; 
                            } else {
                              return new Date(a.nominationTime) - new Date(b.nominationTime);
                            }
                          }).map((user) => (
                            <option key={user.userId} value={user.userId}>
                              {user.name}
                            </option>
                          ))} 
                        </select>
                      </td>
                    );
                  })}

                  <td className="px-1 py-1 border text-xs">
                    {course.collectiveStatus}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-4">
            <button
             className="bg-purple-500 text-white px-2 py-1 rounded-md text-sm"
              onClick={handleFinalizeNominations}
            >
              Finalize Nominations
            </button>

            <button
              onClick={() => setShowCancelledModal(true)}
              className="bg-blue-500 text-white px-2 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 ml-2 text-sm"
            >
              Show Cancelled Nominations
            </button>

            <button
              onClick={handleOfferingsWithNoNominations}
              className="bg-blue-500 text-white px-2 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 ml-2 text-sm"
            >
              Show Offerings with No Nominations
            </button>

            <button
              onClick={downloadXLReport}
              className="bg-blue-500 text-white px-2 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 ml-2 text-sm"
            >
              Download XL Report
            </button>
          </div>
        </div>
      )}
      {showCancelledModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
          <div className="bg-white p-1 rounded-lg shadow-lg max-w-6xl w-full">
            <h3 className="text-xl font-semibold mb-4">Cancelled Offerings</h3>
            {/* Wrapper for the table with scroll */}
            <div className="max-h-96 overflow-y-auto">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Group Course Name</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Component Course Name</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Start Date</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">End Date</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Time</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">User Name</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Status</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Reason</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Alternative SME</th>
                  </tr>
                </thead>
                <tbody>
                  {getCancelledOfferings().map((offering) => (
                    <tr key={offering.nominationId} className="border-b border-gray-200">
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.monthlyOfferingBean.groupCourseName}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.monthlyOfferingBean.componentCourseName}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 whitespace-nowrap">
                        {format(new Date(offering.monthlyOfferingBean.startDate), "dd-MMM-yyyy")}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 whitespace-nowrap">
                        {format(new Date(offering.monthlyOfferingBean.endDate), "dd-MMM-yyyy")}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.monthlyOfferingBean.time}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.userBean.name}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">{offering.confirmationStatus}</td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">{offering.reason}</td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">{offering.alternativeSME}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-4 text-right">
              <button
                onClick={() => setShowCancelledModal(false)}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showNoNominationsModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
          <div className="bg-white p-1 rounded-lg shadow-lg max-w-6xl w-full">
            <h3 className="text-xl font-semibold mb-4">Offerings with No Nominations</h3>
            {/* Wrapper for the table with scroll */}
            <div className="max-h-96 overflow-y-auto">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Group Course Name</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Component Course Name</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Start Date</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">End Date</th>
                    <th className="px-1 py-1 border border-gray-300 text-xs">Time</th>
                  </tr>
                </thead>
                <tbody>
                  {learningOfferingsWithNoNominations.map((offering) => (
                    <tr key={offering.monthlyOfferingId} className="border-b border-gray-200">
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.groupCourseName}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.componentCourseName}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 whitespace-nowrap">
                        {format(new Date(offering.startDate), "dd-MMM-yyyy")}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 whitespace-nowrap">
                        {format(new Date(offering.endDate), "dd-MMM-yyyy")}
                      </td>
                      <td className="px-1 py-1 border border-gray-300 text-xs">
                        {offering.time}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-4 text-right">
              <button
                onClick={() => setShowNoNominationsModal(false)}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedMonth && learningOfferings.length === 0 && (
        <p className="text-center text-gray-700 mt-4">No Data available for the selected month.</p>
      )}
    </div>
  );
}

export default NominationFinalization;